import { render, staticRenderFns } from "./SetMenuButNav.vue?vue&type=template&id=89a27e5a&scoped=true"
import script from "./SetMenuButNav.vue?vue&type=script&lang=js"
export * from "./SetMenuButNav.vue?vue&type=script&lang=js"
import style0 from "./SetMenuButNav.vue?vue&type=style&index=0&id=89a27e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a27e5a",
  null
  
)

export default component.exports